import SMSOptIn from 'components/Content/SMSOptIn/SMSOptIn';
import { withSMSOptInProps } from 'viewModel/content/smsoptin/withSMSOptInProps';

export default withSMSOptInProps(SMSOptIn);
